import type { Environment } from "@/types/common";

/**
 * Return the current build environment based on ENV VAR
 */
export const getEnv = () =>
  String(import.meta.env.VITE_DEPLOY_ENV ?? "local") as Environment;
